import { render, staticRenderFns } from "./CollectionModal3.vue?vue&type=template&id=3882d1f5&"
import script from "./CollectionModal3.vue?vue&type=script&lang=js&"
export * from "./CollectionModal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports